import { getAppDomain } from "./auth";

export const setCookie = (cname: string, cvalue: string, exp: any) => {
  const d = new Date(exp);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    `;path=/;domain=${
      process.env.REACT_APP_ENV === "production" ? "" : ".staging"
    }.zostel.com`;
};

export const getCookie = (cname: string) => {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const deleteCookie = (cname: string, clientId: string) => {
  const domain = getAppDomain(clientId);
  if (domain) {
    const d = new Date();
    var expires = "expires=" + d.toUTCString();
    document.cookie =
      cname +
      "=;" +
      expires +
      `;path=/;domain=${
        process.env.REACT_APP_ENV === "production" ? "" : ".staging"
      }.zostel.com`;
  }
};
